// Secondary Navigation Mobile - Scroll behavior
(function () {
  function initSecondaryNavMobile() {
    const secondaryNav = document.querySelector('secondary-nav-mobile');
    if (!secondaryNav) return;

    // Wait for header and announcement bar heights to be calculated
    function initPositioning() {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const announcementBarHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) || 0;
      const stickyAnnouncementBarEnabled = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-announcement-bar-enabled')) || 0;
      if (headerHeight > 0) {
        secondaryNav.style.setProperty('--header-height', headerHeight + 'px');
      }
      if (announcementBarHeight > 0) {
        secondaryNav.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
      }
      if (stickyAnnouncementBarEnabled > 0) {
        secondaryNav.style.setProperty('--sticky-announcement-bar-enabled', stickyAnnouncementBarEnabled);
      }
    }

    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPositioning);
    } else {
      initPositioning();
    }

    // Also try after a short delay to ensure header height is set
    setTimeout(initPositioning, 100);

    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateSticky() {
      const currentScrollY = window.scrollY;
      const scrollDifference = lastScrollY - currentScrollY;
      // Show when at top of page or scrolling up (after 100px), hide when scrolling down
      if (currentScrollY <= 100 || (scrollDifference > 0 && currentScrollY > 100)) {
        secondaryNav.classList.add('is-sticky');
      } else if (scrollDifference < 0 && currentScrollY > 100) {
        secondaryNav.classList.remove('is-sticky');
      }
      lastScrollY = currentScrollY;
      ticking = false;
    }

    // Check initial state
    updateSticky();

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateSticky);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSecondaryNavMobile);
  } else {
    initSecondaryNavMobile();
  }

  // Also run after a delay to handle dynamic content
  setTimeout(initSecondaryNavMobile, 100);

  // Rebuy Frequently Bought Together - Expand/Collapse
  function setupRebuyBundleWidget() {
    const REBUY_WIDGET_SELECTOR = '[data-rebuy-shopify-product-ids]';
    const PRODUCT_INFO_SELECTOR = '.product-info';
    const MAX_WAIT_TIME = 10000; // 10 seconds max wait
    const POLL_INTERVAL = 100;

    let dom = {};
    let isInitialized = false;
    let pollTimeout = null;
    let startTime = Date.now();

    // Cache DOM elements once widget is ready
    const cacheDom = () => {
      const rebuyWidget = document.querySelector(`${PRODUCT_INFO_SELECTOR} ${REBUY_WIDGET_SELECTOR}`);
      if (!rebuyWidget) return false;

      dom.rebuyWidget = rebuyWidget;
      dom.widgetActions = rebuyWidget.querySelector('.rebuy-bundle__actions');
      dom.widgetItems = rebuyWidget.querySelector('.rebuy-bundle__items');
      dom.widgetImages = rebuyWidget.querySelector('.rebuy-bundle__images');
      dom.accordionButton = rebuyWidget.querySelector('#rebuy-accordion-button');
      return true;
    };

    // Update button text with selected items count
    const updateButtonText = () => {
      if (!dom.widgetActions || !dom.widgetItems) return;

      const widgetAtcButton = dom.widgetActions.querySelector('.rebuy-bundle__actions-buttons .rebuy-button');
      if (!widgetAtcButton) return;

      const selectedItems = dom.widgetItems.querySelectorAll('.rebuy-product-block.is-selected');

      if (selectedItems.length === 1) {
        widgetAtcButton.innerHTML = `<span>Add 1 Product to Cart</span>`;
      } else {
        widgetAtcButton.innerHTML = `<span>Add ${selectedItems.length} Products to Cart</span>`;
      }
    };

    // Setup accordion toggle button
    const setupAccordion = () => {
      if (!dom.widgetActions || !dom.widgetItems || dom.accordionButton) return;

      const accordionButton = document.createElement('div');
      accordionButton.className = 'rebuy-bundle__actions-accordion-button';

      const isOpened = dom.widgetItems.classList.contains('opened');
      accordionButton.innerHTML = `<a id="rebuy-accordion-button" class="rebuy-accordion-button${isOpened ? ' opened' : ''}">${isOpened ? 'Collapse Details' : 'Show Details'}</a>`;

      dom.widgetActions.append(accordionButton);
      dom.accordionButton = accordionButton.querySelector('#rebuy-accordion-button');
    };

    // Clone product images to product info sections
    const setupProductImages = () => {
      if (!dom.widgetImages || !dom.widgetItems) return;

      const widgetImages = dom.widgetImages.querySelectorAll('.rebuy-bundle__image');
      widgetImages.forEach((widgetImage) => {
        // Find product-id class more efficiently
        const productIdClass = Array.from(widgetImage.classList).find((cls) => cls.includes('product-id-'));
        if (!productIdClass) return;

        const productInfo = dom.widgetItems.querySelector(`.${productIdClass} .rebuy-product-info`);
        if (productInfo && !productInfo.querySelector('.rebuy-bundle__image')) {
          productInfo.append(widgetImage.cloneNode(true));
        }
      });
    };

    // Handle accordion toggle
    const handleAccordionToggle = (button) => {
      if (!dom.widgetItems) return;

      const isOpened = button.classList.contains('opened');

      if (isOpened) {
        button.classList.remove('opened');
        button.textContent = 'Show Details';
        dom.widgetItems.classList.remove('opened');
        // Scroll to widget after collapse animation
        setTimeout(() => {
          if (dom.rebuyWidget) {
            dom.rebuyWidget.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 500);
      } else {
        button.classList.add('opened');
        button.textContent = 'Collapse Details';
        dom.widgetItems.classList.add('opened');
      }
    };

    // Initialize event listeners (only once)
    const attachEventListeners = () => {
      if (isInitialized) return;

      // Use event delegation on the widget container for better performance
      if (dom.rebuyWidget) {
        dom.rebuyWidget.addEventListener('click', (e) => {
          const button = e.target.closest('#rebuy-accordion-button');
          if (button) {
            handleAccordionToggle(button);
          }
        });

        dom.rebuyWidget.addEventListener('change', (e) => {
          if (e.target.closest('.rebuy-checkbox')) {
            updateButtonText();
            // Re-check accordion state if needed
            if (!dom.accordionButton) {
              setupAccordion();
            }
          }
        });
      }

      isInitialized = true;
    };

    // Wait for widget to be ready using polling with timeout
    const waitForRebuyWidget = () => {
      if (isInitialized) return;

      // Check if widget exists and is ready
      if (cacheDom() && dom.rebuyWidget.querySelector('.rebuy-widget')) {
        updateButtonText();
        setupAccordion();
        setupProductImages();
        attachEventListeners();
        return;
      }

      // Stop polling after max wait time
      if (Date.now() - startTime > MAX_WAIT_TIME) {
        return;
      }

      // Continue polling
      pollTimeout = setTimeout(waitForRebuyWidget, POLL_INTERVAL);
    };

    // Cleanup function
    const cleanup = () => {
      if (pollTimeout) {
        clearTimeout(pollTimeout);
        pollTimeout = null;
      }
    };

    // Start initialization
    waitForRebuyWidget();

    // Cleanup on page unload
    window.addEventListener('beforeunload', cleanup);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupRebuyBundleWidget);
  } else {
    setupRebuyBundleWidget();
  }
})();

// Enhanced MarqueeText - JavaScript-based animation instead of CSS
(function() {
  function enhanceMarqueeTextElement(element) {
    if (element._jsAnimationEnhanced) return;
    element._jsAnimationEnhanced = true;

    const animations = [];
    let resizeObserver = null;

    function calculateAndAnimate() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const scrollingSpeed = parseInt(element.getAttribute('scrolling-speed') || 5);
      const containerWidth = element.clientWidth;
      const textElements = element.querySelectorAll('.scrolling-text__text');
      
      if (textElements.length === 0) {
        setTimeout(calculateAndAnimate, 100);
        return;
      }

      // Calculate total width of all elements and store individual widths
      let totalWidth = 0;
      const elementWidths = [];
      const elementTexts = []; // Store text content to detect pattern
      textElements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        elementWidths.push(width);
        totalWidth += width;
        // Get text content to detect where one set ends
        const textContent = el.textContent.trim();
        elementTexts.push(textContent);
      });
      
      if (totalWidth === 0 || containerWidth === 0) {
        setTimeout(calculateAndAnimate, 100);
        return;
      }
      
      // Calculate width of one complete set by detecting the pattern
      // For scrolling-text: content is duplicated 10 times
      // We need to find where the first complete set ends by detecting when the first text repeats
      let oneSetWidth = 0;
      let firstTextContent = null;
      let foundFirstSet = false;
      
      // Find the first complete set by detecting when the first text content appears again
      for (let i = 0; i < textElements.length; i++) {
        const textContent = elementTexts[i];
        
        // Skip empty/separator elements (they're usually icons with minimal text)
        const isSeparator = !textContent || textContent.length < 2;
        
        if (!isSeparator) {
          if (firstTextContent === null) {
            // This is the first text element - remember it
            firstTextContent = textContent;
            oneSetWidth += elementWidths[i];
          } else if (textContent === firstTextContent && i > 0) {
            // We've found the first text again - this marks the end of the first set
            // The set ends at the previous element
            foundFirstSet = true;
            break;
          } else {
            // Still in the first set, add to width
            oneSetWidth += elementWidths[i];
          }
        } else {
          // Separator - always add to set width
          oneSetWidth += elementWidths[i];
        }
      }
      
      // Fallback: if we couldn't detect the pattern, use total / 10
      if (!foundFirstSet || oneSetWidth === 0) {
        const repetitions = 10;
        oneSetWidth = totalWidth / repetitions;
      }
      
      // Calculate duration based on one set width for seamless looping
      const slowFactor = 1 + (Math.min(1600, containerWidth) - 375) / (1600 - 375);
      const durationSeconds = scrollingSpeed * slowFactor * (oneSetWidth / containerWidth);
      
      const transformFlip = getComputedStyle(element).getPropertyValue('--transform-logical-flip') || '1';
      const isRTL = document.documentElement.dir === 'rtl';
      const direction = (isRTL ? -1 : 1) * parseFloat(transformFlip);
      
      // Clean up existing animations
      animations.forEach(anim => {
        if (anim && anim.cancel) anim.cancel();
      });
      animations.length = 0;
      
      // Calculate the distance to move - exactly one set width
      // All elements move by the same distance to maintain their relative positions
      const moveDistance = -oneSetWidth * direction;
      
      // Animate each text element - all move together by the same distance
      // This maintains the natural inline flow without gaps
      textElements.forEach((el) => {
        // Reset transform - elements stay in their natural inline positions
        el.style.transform = 'translateX(0)';
        
        // All elements move by exactly one set width
        // When the first set completes, the duplicate set is in the exact same position
        const animation = el.animate(
          [
            { transform: 'translateX(0)' },
            { transform: `translateX(${moveDistance}px)` }
          ],
          {
            duration: durationSeconds * 1000,
            iterations: Infinity,
            easing: 'linear',
            fill: 'both'
          }
        );
        
        animations.push(animation);
      });
    }

    // Set up ResizeObserver
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        calculateAndAnimate();
      });
      resizeObserver.observe(element);
    }

    // Initial animation
    requestAnimationFrame(() => {
      calculateAndAnimate();
    });

    // Cleanup on disconnect
    const originalDisconnect = element.disconnectedCallback;
    element.disconnectedCallback = function() {
      animations.forEach(anim => {
        if (anim && anim.cancel) anim.cancel();
      });
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      if (originalDisconnect) {
        originalDisconnect.call(this);
      }
    };
  }

  function initMarqueeTextEnhancement() {
    document.querySelectorAll('marquee-text').forEach(enhanceMarqueeTextElement);
  }

  // Use MutationObserver to catch dynamically added elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.tagName === 'MARQUEE-TEXT') {
            enhanceMarqueeTextElement(node);
          }
          node.querySelectorAll('marquee-text').forEach(enhanceMarqueeTextElement);
        }
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initMarqueeTextEnhancement();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    initMarqueeTextEnhancement();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// Rebuy Cart Integration - Refresh side cart when items are added via Rebuy widget
(function() {
  let rebuyCartUpdateTimeout = null;
  let lastCartItemCount = null;
  let isUpdating = false;
  let listenersAttached = false;
  let lastUpdateTime = 0;
  const MIN_UPDATE_INTERVAL = 2000; // Minimum 2 seconds between updates

  // Get current cart data
  async function getCartData() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.warn('Failed to fetch cart:', error);
    }
    return null;
  }

  // Update cart using the theme's built-in cart:change event with sections
  async function updateCartDrawer() {
    // Prevent multiple simultaneous updates
    if (isUpdating) {
      return;
    }
    
    // Throttle updates - don't update if we just updated recently
    const now = Date.now();
    if (now - lastUpdateTime < MIN_UPDATE_INTERVAL) {
      return;
    }
    
    isUpdating = true;
    lastUpdateTime = now;

    try {
      const cartDrawer = document.querySelector('#cart-drawer');
      if (!cartDrawer) {
        isUpdating = false;
        return;
      }

      // Get cart data
      const cartData = await getCartData();
      if (!cartData) {
        isUpdating = false;
        return;
      }

      // Find the section element to get section ID
      const sectionElement = cartDrawer.closest('.shopify-section');
      if (!sectionElement) {
        isUpdating = false;
        return;
      }

      const sectionId = sectionElement.id.replace('shopify-section-', '');
      if (!sectionId) {
        isUpdating = false;
        return;
      }

      // Preserve Rebuy widget - store reference before update
      const rebuyContainer = cartDrawer.querySelector('[data-rebuy-id]');
      const rebuyContainerHTML = rebuyContainer ? rebuyContainer.outerHTML : null;

      // Fetch updated section HTML
      const sectionResponse = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=${sectionId}`);
      if (!sectionResponse.ok) {
        isUpdating = false;
        return;
      }

      let sectionHTML = await sectionResponse.text();
      
      // Inject Rebuy widget into the section HTML before theme processes it
      // This prevents the widget from being removed during the update
      if (rebuyContainerHTML && !sectionHTML.includes('data-rebuy-id="259079"')) {
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionHTML, 'text/html');
          const updatedSection = doc.querySelector(`#shopify-section-${sectionId}`);
          
          if (updatedSection) {
            const updatedCartDrawer = updatedSection.querySelector('#cart-drawer');
            if (updatedCartDrawer) {
              const rebuyParent = updatedCartDrawer.querySelector('.v-stack.gap-6, .v-stack.gap-8');
              if (rebuyParent && !rebuyParent.querySelector('[data-rebuy-id]')) {
                // Create a temporary container to hold the Rebuy HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = rebuyContainerHTML;
                const rebuyNode = tempDiv.firstElementChild;
                
                if (rebuyNode) {
                  // Append the Rebuy widget to the parent
                  rebuyParent.appendChild(rebuyNode);
                  
                  // Extract the modified section HTML
                  // Get the section element's outerHTML
                  sectionHTML = updatedSection.outerHTML;
                }
              }
            }
          }
        } catch (error) {
          console.warn('Error injecting Rebuy widget into section HTML:', error);
          // Fallback: use string replacement if DOM parsing fails
          const vStackClosePattern = /(<div\s+class="v-stack\s+gap-6\s+sm:gap-8">[\s\S]*?<\/div>\s*<\/div>)/;
          const match = sectionHTML.match(vStackClosePattern);
          if (match) {
            sectionHTML = sectionHTML.replace(
              match[1],
              match[1].replace('</div>', rebuyContainerHTML + '</div>')
            );
          }
        }
      }
      
      // Trigger cart:change event with sections data - let theme handle the update
      const sections = {};
      sections[sectionId] = sectionHTML;
      
      // Reset updating flag after theme processes the update
      // Note: Rebuy initialization is now handled by the theme's _onCartChanged method
      // to prevent multiple reinitializations. We don't need to call it here.
      setTimeout(() => {
        isUpdating = false;
      }, 500);
      
      // Only dispatch cart:change if this is a Rebuy-triggered update
      // Don't interfere with normal cart operations (item removal, quantity changes)
      document.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'rebuy:add',
          cart: {
            ...cartData,
            sections: sections
          }
        }
      }));
      
      // Update lastCartItemCount immediately to prevent duplicate updates
      lastCartItemCount = cartData.item_count;

    } catch (error) {
      console.warn('Error updating cart drawer:', error);
      isUpdating = false;
    }
  }

  // Check for cart changes and update (with debouncing)
  async function checkCartAndUpdate() {
    // Clear any pending updates
    if (rebuyCartUpdateTimeout) {
      clearTimeout(rebuyCartUpdateTimeout);
      rebuyCartUpdateTimeout = null;
    }

    // Don't check if already updating or if update was too recent
    if (isUpdating) return;
    
    const now = Date.now();
    if (now - lastUpdateTime < MIN_UPDATE_INTERVAL) {
      return;
    }

    const cartData = await getCartData();
    if (cartData && cartData.item_count !== null && cartData.item_count !== lastCartItemCount) {
      lastCartItemCount = cartData.item_count;
      await updateCartDrawer();
    }
  }

  // Initialize cart item count
  async function initCartTracking() {
    const cartData = await getCartData();
    if (cartData) {
      lastCartItemCount = cartData.item_count;
    }
  }

  // Debounced update function
  function scheduleCartUpdate(delay = 1500) {
    // Clear any existing timeout
    if (rebuyCartUpdateTimeout) {
      clearTimeout(rebuyCartUpdateTimeout);
      rebuyCartUpdateTimeout = null;
    }
    
    // Don't schedule if already updating or if update was too recent
    if (isUpdating) return;
    
    const now = Date.now();
    if (now - lastUpdateTime < MIN_UPDATE_INTERVAL) {
      return;
    }
    
    // Schedule the update
    rebuyCartUpdateTimeout = setTimeout(() => {
      rebuyCartUpdateTimeout = null;
      checkCartAndUpdate();
    }, delay);
  }

  // Listen for Rebuy button clicks in cart widget (fallback if events don't fire)
  function setupRebuyCartListener() {
    if (listenersAttached) return;
    
    // Use event delegation to catch dynamically added Rebuy buttons
    document.addEventListener('click', function rebuyClickHandler(event) {
      // Don't interfere with normal cart operations (remove buttons, quantity changes)
      const isRemoveButton = event.target.closest('line-item-remove-button, [is="remove-button"]');
      const isQuantityInput = event.target.closest('line-item-quantity, .quantity-input');
      
      if (isRemoveButton || isQuantityInput) {
        return; // Let theme handle these normally
      }
      
      const rebuyButton = event.target.closest('.rebuy-button, [class*="rebuy-button"]');
      if (rebuyButton && document.querySelector('#cart-drawer')) {
        // Only trigger if it's actually a button that adds to cart
        const isAddButton = rebuyButton.classList.contains('rebuy-button') || 
                           rebuyButton.closest('.rebuy-product-actions');
        
        if (isAddButton) {
          // Only schedule if conditions are met
          if (!isUpdating && !rebuyCartUpdateTimeout) {
            const now = Date.now();
            if (now - lastUpdateTime >= MIN_UPDATE_INTERVAL) {
              scheduleCartUpdate(1500);
            }
          }
        }
      }
    }, true); // Use capture phase to catch events early
  }

  // Listen for Rebuy-specific events (preferred method)
  function setupRebuyEventListeners() {
    if (listenersAttached) return;
    
    // Rebuy may fire custom events - listen for common ones
    const rebuyEvents = [
      'rebuy:cart:updated',
      'rebuy:cart:change'
    ];

    rebuyEvents.forEach(eventName => {
      document.addEventListener(eventName, function rebuyEventHandler() {
        // Only schedule if conditions are met
        if (!isUpdating && !rebuyCartUpdateTimeout) {
          const now = Date.now();
          if (now - lastUpdateTime >= MIN_UPDATE_INTERVAL) {
            // Schedule update with shorter delay since event means update is in progress
            scheduleCartUpdate(1000);
          }
        }
      }, { once: false });
    });
  }

  // Initialize when DOM is ready (only once)
  function initRebuyCartIntegration() {
    // Prevent duplicate initialization
    if (listenersAttached) return;
    
    initCartTracking();
    setupRebuyCartListener();
    setupRebuyEventListeners();
    listenersAttached = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRebuyCartIntegration);
  } else {
    initRebuyCartIntegration();
  }
})();

// Subscription CTA and Frequency Selector Handler
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Handle subscription upgrade button click
    document.addEventListener('click', async function(e) {
      if (e.target.classList.contains('subscription-upgrade-btn')) {
        e.preventDefault();
        const button = e.target;
        const lineKey = button.getAttribute('data-line-key');
        const sellingPlanId = button.getAttribute('data-selling-plan-id');
        const variantId = button.getAttribute('data-variant-id');
        
        if (!lineKey || !sellingPlanId) return;
        
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        
        try {
          const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: lineKey,
              selling_plan: sellingPlanId
            })
          });
          
          if (response.ok) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (window.themeVariables?.settings?.pageType === 'cart') {
              window.location.reload();
            }
          } else {
            const error = await response.json();
            console.error('Subscription upgrade failed:', error);
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        } catch (error) {
          console.error('Error upgrading to subscription:', error);
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
    
    // Handle subscription frequency change
    document.addEventListener('change', async function(e) {
      if (e.target.classList.contains('subscription-frequency-select')) {
        const select = e.target;
        const lineKey = select.getAttribute('data-line-key');
        const sellingPlanId = select.value;
        
        if (!lineKey) return;
        
        select.disabled = true;
        select.setAttribute('aria-busy', 'true');
        
        try {
          const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: lineKey,
              selling_plan: sellingPlanId || null
            })
          });
          
          if (response.ok) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (window.themeVariables?.settings?.pageType === 'cart') {
              window.location.reload();
            }
          } else {
            const error = await response.json();
            console.error('Subscription change failed:', error);
            select.disabled = false;
            select.removeAttribute('aria-busy');
          }
        } catch (error) {
          console.error('Error changing subscription:', error);
          select.disabled = false;
          select.removeAttribute('aria-busy');
        }
      }
    });
  });

  // Handle Rebuy cart changes on main cart page
  // This code runs outside DOMContentLoaded to ensure it executes immediately
  // Reload when items are added or removed to ensure GWP state is correct
  const isCartPage = window.themeVariables?.settings?.pageType === 'cart' || 
                    window.location.pathname === '/cart' || 
                    window.location.pathname.includes('/cart');
  
  if (isCartPage) {
    let isReloading = false;
    let rebuyReloadTimeout = null;
    let pageLoadTime = Date.now();
    let initialCartItemCount = null;
    const IGNORE_EVENTS_FOR_MS = 2000; // Ignore events in first 2 seconds after page load

    // Helper function to identify Rebuy GWP items
    const isRebuyGWP = (item) => {
      if (item.final_line_price !== 0) return false;
      if (!item.properties || item.properties.length === 0) return false;
      for (const prop of item.properties) {
        const key = prop[0] || '';
        const value = prop[1] || '';
        // Check for specific _attribution property
        if (key === '_attribution' && value === 'Rebuy Gift with Purchase') {
          return true;
        }
      }
      return false;
    };

    // Helper function to check if item is a subscription (qualifying product)
    const isSubscriptionItem = (item) => {
      // Check if item has a selling_plan_allocation (active subscription)
      return item.selling_plan_allocation !== null && item.selling_plan_allocation !== undefined;
    };

    // Function to check DOM for GWP items and remove them if no subscription items exist
    const checkAndRemoveInvalidGWP = async () => {
      try {
        // First, check the DOM for GWP items (free badges)
        const gwpBadges = document.querySelectorAll('.line-item__free-badge');
        
        if (gwpBadges.length === 0) {
          return false;
        }
        
        // Get the cart to check for subscription items
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await response.json();
        
        // Check if there are any subscription items (qualifying products) in the cart API
        const subscriptionItems = cart.items ? cart.items.filter(item => isSubscriptionItem(item)) : [];
        
        // Also check DOM for subscription items (items with selling plan selectors)
        const subscriptionSelectors = document.querySelectorAll('.subscription-frequency-select, .subscription-upgrade-btn');
        const hasSubscriptionInDOM = subscriptionSelectors.length > 0;
        
        // If no subscription items exist but GWP items do, remove GWP items
        if (subscriptionItems.length === 0 && !hasSubscriptionInDOM) {
          // Find all GWP line items and get their remove links
          const gwpLineItems = Array.from(gwpBadges).map(badge => {
            const lineItem = badge.closest('line-item, tr');
            const removeLink = lineItem?.querySelector('a[href*="/cart/change"]');
            return removeLink?.href;
          }).filter(Boolean);
          
          if (gwpLineItems.length > 0) {
            // Extract line keys from URLs and remove items
            const removePromises = gwpLineItems.map(url => {
              const urlObj = new URL(url);
              const lineKey = urlObj.searchParams.get('id');
              return fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: lineKey, quantity: 0 })
              });
            });
            
            const results = await Promise.all(removePromises);
            const allSuccessful = results.every(r => r.ok);
            
            if (allSuccessful) {
              setTimeout(() => {
                window.location.reload();
              }, 300);
              return true;
            }
          }
        }
        return false;
      } catch (error) {
        console.error('[GWP Check] Error:', error);
        return false;
      }
    };

    // Initial check after page load (with delay to ensure cart is ready)
    setTimeout(() => {
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
        .then(response => response.json())
        .then(cart => {
          initialCartItemCount = cart.item_count;
          checkAndRemoveInvalidGWP();
        })
        .catch(error => {
          console.error('[Cart Page Load] Error fetching cart:', error);
        });
    }, 500);

    // Periodic check every 2 seconds to catch GWP items that shouldn't exist
    const gwpCheckInterval = setInterval(() => {
      checkAndRemoveInvalidGWP().then(removed => {
        if (removed) {
          clearInterval(gwpCheckInterval);
        }
      });
    }, 2000);

    // Stop checking after 10 seconds to avoid infinite loops
    setTimeout(() => {
      clearInterval(gwpCheckInterval);
    }, 10000);

    // Function to handle Rebuy cart changes
    function handleRebuyCartChange(cartData) {
      // Don't reload if already reloading
      if (isReloading) {
        return;
      }
      
      // Ignore events that fire too soon after page load
      if (Date.now() - pageLoadTime < IGNORE_EVENTS_FOR_MS) {
        return;
      }
      
      // Reload if cart item count changed (item added or removed)
      const newItemCount = cartData?.item_count;
      if (newItemCount !== null && initialCartItemCount !== null && newItemCount !== initialCartItemCount) {
        // Clear any existing timeout
        if (rebuyReloadTimeout) {
          clearTimeout(rebuyReloadTimeout);
        }
        
        // Set flag and reload after delay to give Rebuy time to process
        isReloading = true;
        rebuyReloadTimeout = setTimeout(function() {
          window.location.reload();
        }, 500);
      }
    }

    // Listen for rebuy:cart.change events
    document.addEventListener('rebuy:cart.change', function() {
      // Fetch current cart to check item count
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
        .then(response => response.json())
        .then(cart => {
          handleRebuyCartChange(cart);
        })
        .catch(() => {});
    });

    // Listen for cart:change events that originate from Rebuy
    document.addEventListener('cart:change', function(event) {
      if (event.detail?.baseEvent === 'rebuy:cart.change' && event.detail?.cart) {
        handleRebuyCartChange(event.detail.cart);
      }
    });

    // Note: Item removals are handled by LineItemQuantity class in theme.js
    // which already reloads the page after a delay to give Rebuy time to process
  }
})();

/**
 * Product gallery: ensure benefit icons slide is not shown first on mobile when the first image is hidden (variant filter).
 * If the selected slide is hidden, select the first visible *media* slide so we never land on benefit as the initial view.
 */
(function () {
  function correctBenefitCarouselOrder(carousel) {
    if (!carousel || !carousel.items || !carousel.items.length) return;
    var hasBenefit = Array.from(carousel.items).some(function (el) {
      return el.getAttribute && el.getAttribute('data-media-type') === 'benefit-icons';
    });
    if (!hasBenefit) return;
    var selectedSlide = carousel.selectedSlide || carousel.items[carousel.selectedIndex];
    if (!selectedSlide) return;
    if (selectedSlide.offsetParent !== null) return;
    var visible = carousel.visibleItems || Array.from(carousel.items).filter(function (el) { return el.offsetParent !== null; });
    var firstVisibleMedia = visible.find(function (el) {
      return el.getAttribute && el.getAttribute('data-media-type') !== 'benefit-icons';
    });
    if (firstVisibleMedia) {
      var idx = Array.from(carousel.items).indexOf(firstVisibleMedia);
      if (idx !== -1) carousel.select(idx, { animate: false });
    }
  }

  function runOnCarousels() {
    document.querySelectorAll('product-gallery media-carousel').forEach(function (carousel) {
      setTimeout(function () {
        correctBenefitCarouselOrder(carousel);
      }, 0);
    });
  }

  document.addEventListener('carousel:filter', function (e) {
    var carousel = e.target;
    if (carousel.tagName && carousel.tagName.toLowerCase() === 'media-carousel') {
      setTimeout(function () {
        correctBenefitCarouselOrder(carousel);
      }, 0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOnCarousels);
  } else {
    runOnCarousels();
  }
  setTimeout(runOnCarousels, 300);
})();

// Bundle Property Sync
// Promotes the hidden _rc_bundle property to a visible "Bundle: Included"
// property so it persists through to checkout. The Liquid template handles
// immediate display via _rc_bundle; this JS ensures the visible property
// exists in the cart data before the customer reaches checkout.
//
// Strategy: sync proactively when the cart changes so the property is already
// written by the time the customer clicks checkout. The checkout interceptor
// runs a final check as a safety net — usually a no-op instant redirect.
(function () {
  const root = Shopify.routes.root;
  const checkoutUrl = root + 'checkout';
  let syncing = false;

  async function syncBundleProperties() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      for (const item of cart.items) {
        const props = item.properties || {};
        if (props._rc_bundle && !props.Bundle) {
          await fetch(`${root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, properties: { ...props, Bundle: 'Included' } })
          });
        }
      }
    } catch (err) {
      console.error('[Bundle Sync]', err);
    } finally {
      syncing = false;
    }
  }

  // Proactive: sync whenever the cart changes so properties are pre-set
  let debounceTimer;
  function onCartChange() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncBundleProperties, 500);
  }

  document.addEventListener('cart:change', onCartChange);
  document.addEventListener('cart:refresh', onCartChange);
  document.addEventListener('variant:add', onCartChange);

  // Also run once on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(syncBundleProperties, 300));
  } else {
    setTimeout(syncBundleProperties, 300);
  }

  // Safety net: final check on checkout click
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="checkout"]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    btn.setAttribute('aria-busy', 'true');

    syncBundleProperties()
      .finally(() => {
        window.location.href = checkoutUrl;
      });
  }, true);
})();

/**
 * WAVE / ADA remediation for third-party and page-content issues the theme
 * cannot fix in Liquid alone (OneTrust CMP, tracking pixels, rich-text images).
 */
(function () {
  const TRACKING_HOST_RE = /(adentifi\.com|roeye\.com|bat\.bing\.com|doubleclick\.net|google-analytics\.com|googletagmanager\.com|facebook\.com\/tr|adsrvr\.org)/i;

  const CERT_ALT_BY_SRC = [
    [/b_corp/i, 'B Corp Certified seal'],
    [/plastic.?neutral/i, 'Certified Plastic Neutral seal'],
    [/usda.?organic|organic.?seal/i, 'USDA Organic Certification seal'],
    [/non.?gmo/i, 'Non-GMO Project Verified seal'],
    [/kosher/i, 'Certified Kosher seal'],
    [/glyphosate/i, 'Certified Glyphosate Residue Free seal'],
    [/vegan/i, 'Certified Vegan seal'],
    [/nsf/i, 'NSF Certified Sport seal'],
    [/igen/i, 'iGEN Non-GMO Tested seal'],
    [/pesticide/i, 'Tested for 150+ Pesticides and Herbicides seal'],
    [/gluten/i, 'Gluten Free seal'],
    [/vegetarian/i, 'Vegetarian seal'],
    [/doctor.?formulat/i, 'Doctor Formulated seal'],
    [/1_ftp|1.?for.?the.?planet|ftp_full/i, '1% for the Planet'],
  ];

  function fixOneTrustEmptyLabel(root) {
    const labels = [];
    if (root && root.nodeType === 1) {
      if (root.matches?.('label.ot-scrn-rdr, label[for="vendor-search-handler"]')) labels.push(root);
      root.querySelectorAll?.('label.ot-scrn-rdr, label[for="vendor-search-handler"]').forEach((label) => labels.push(label));
    } else {
      document.querySelectorAll('label.ot-scrn-rdr, label[for="vendor-search-handler"]').forEach((label) => labels.push(label));
    }

    labels.forEach((label) => {
      if ((label.textContent || '').trim()) return;
      label.textContent = 'Search';
      const inputId = label.getAttribute('for');
      const input = inputId ? document.getElementById(inputId) : null;
      if (input && !input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
        input.setAttribute('aria-label', 'Search');
      }
    });
  }

  function isTrackingOrSpacerImage(img) {
    const src = img.currentSrc || img.src || '';
    if (TRACKING_HOST_RE.test(src)) return true;
    const width = img.getAttribute('width');
    const height = img.getAttribute('height');
    if (width === '0' || height === '0' || width === '1' || height === '1') return true;
    if (img.naturalWidth <= 1 && img.naturalHeight <= 1 && img.complete) return true;
    const style = (img.getAttribute('style') || '').toLowerCase();
    if (style.includes('display:none') || style.includes('display: none')) return true;
    return false;
  }

  function altFromFilename(src) {
    try {
      const path = new URL(src, window.location.origin).pathname;
      const file = path.split('/').pop() || '';
      const name = file
        .replace(/\.[a-z0-9]+$/i, '')
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      return name || '';
    } catch (e) {
      return '';
    }
  }

  function fixMissingImageAlts(root) {
    const images = [];
    if (root && root.nodeType === 1) {
      if (root.matches?.('img')) images.push(root);
      root.querySelectorAll?.('img').forEach((img) => images.push(img));
    } else {
      document.querySelectorAll('img').forEach((img) => images.push(img));
    }

    images.forEach((img) => {
      if (img.hasAttribute('alt') && (img.getAttribute('alt') || '').trim() !== '') return;

      if (!img.hasAttribute('alt') && isTrackingOrSpacerImage(img)) {
        img.setAttribute('alt', '');
        img.setAttribute('role', 'presentation');
        return;
      }

      const src = img.currentSrc || img.src || '';
      for (const [pattern, label] of CERT_ALT_BY_SRC) {
        if (pattern.test(src)) {
          img.setAttribute('alt', label);
          return;
        }
      }

      if (!img.hasAttribute('alt')) {
        const nearby =
          img.closest('figure, li, td, .prose, .rte, strong, p')?.querySelector('h1, h2, h3, h4, h5, h6, strong, b') ||
          img.parentElement?.nextElementSibling ||
          img.parentElement?.previousElementSibling;
        const nearbyText = (nearby?.textContent || '').replace(/\s+/g, ' ').trim();
        if (nearbyText) {
          img.setAttribute('alt', nearbyText.slice(0, 120));
          return;
        }

        const fromFile = altFromFilename(src);
        if (fromFile) {
          img.setAttribute('alt', fromFile);
          return;
        }

        img.setAttribute('alt', '');
      } else if ((img.getAttribute('alt') || '').trim() === '') {
        // Linked images with empty alt fail WAVE; prefer a meaningful label.
        const link = img.closest('a');
        if (link) {
          for (const [pattern, label] of CERT_ALT_BY_SRC) {
            if (pattern.test(src)) {
              img.setAttribute('alt', label);
              if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', label);
              return;
            }
          }
          const fromFile = altFromFilename(src);
          if (fromFile) {
            img.setAttribute('alt', fromFile);
            if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', fromFile);
          }
        }
      }
    });
  }

  function runA11yRemediation(root) {
    fixOneTrustEmptyLabel(root);
    fixMissingImageAlts(root);
  }

  function start() {
    runA11yRemediation(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            runA11yRemediation(node);
          });
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    // OneTrust injects late; re-run a few times.
    [500, 1500, 3000, 6000].forEach((ms) => setTimeout(() => runA11yRemediation(document), ms));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
